import TabHeader from './TabHeader'
import TabContent from './TabContext'

import useViewModel from './ViewModel'

import { TabsButtonGroupProps } from 'Types/Presentation/Components/Tabs/ButtonGroup'

const TabsButtonGroup: React.FC<TabsButtonGroupProps> = ({
	tabNames,
	tabContents,
	manualActiveTab,
	changeTab,
}) => {
	const { activeTab, handleTabClick } = useViewModel(changeTab)

	return (
		<>
			<TabHeader
				tabNames={tabNames}
				activeTab={manualActiveTab !== undefined ? manualActiveTab : activeTab}
				handleTabClick={handleTabClick}
			/>

			<TabContent tabContents={tabContents} activeTab={activeTab} />
		</>
	)
}

export default TabsButtonGroup
